var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunc1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8.75,
    fill: "#009AD9",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_1936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9999 18.6294V17.5156H40.2109V18.6294H42.0485V37.371H40.2109V38.4848H44.9999V37.371H43.1623V18.6294H44.9999Z",
    fill: "#009AD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2066 33.9532L16.8116 21.2959C17.2024 20.4231 17.9142 19.8945 18.8793 19.8945H19.0861C20.0505 19.8945 20.7399 20.423 21.1303 21.2959L26.7355 33.9532C26.8503 34.206 26.9194 34.4356 26.9194 34.6654C26.9194 35.6072 26.1842 36.3653 25.2423 36.3653C24.4154 36.3653 23.864 35.8829 23.5425 35.1477L22.463 32.621H15.3877L14.262 35.2627C13.9633 35.9518 13.3662 36.3653 12.6311 36.3653C11.7119 36.3653 11 35.6302 11 34.7113C11 34.4586 11.0918 34.206 11.2066 33.9532ZM21.1535 29.4968L18.9251 24.1903L16.6969 29.4968H21.1535ZM28.5954 32.6898V32.6438C28.5954 29.9561 30.6399 28.7157 33.5572 28.7157C34.7978 28.7157 35.6938 28.9224 36.5668 29.2211V29.0144C36.5668 27.567 35.6707 26.7632 33.9249 26.7632C32.9601 26.7632 32.1791 26.9009 31.5129 27.1078C31.3063 27.1767 31.1683 27.1995 31.0073 27.1995C30.2035 27.1995 29.5603 26.5793 29.5603 25.7754C29.5603 25.1551 29.9507 24.6268 30.5019 24.42C31.6046 24.0065 32.7993 23.7768 34.4303 23.7768C36.3367 23.7768 37.7152 24.2821 38.5882 25.155C39.507 26.0738 39.9205 27.4293 39.9205 29.0832V34.6882C39.9205 35.6302 39.1624 36.3652 38.2205 36.3652C37.2097 36.3652 36.5437 35.6531 36.5437 34.9179V34.8949C35.6937 35.8367 34.5219 36.4569 32.8223 36.4569C30.5019 36.4571 28.5954 35.125 28.5954 32.6898ZM36.6124 31.8857V31.2655C36.0152 30.9899 35.2342 30.8061 34.3843 30.8061C32.891 30.8061 31.9723 31.4034 31.9723 32.5059V32.5519C31.9723 33.4938 32.7533 34.045 33.8788 34.045C35.5098 34.0451 36.6124 33.1493 36.6124 31.8857Z",
    fill: "#009AD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_1936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunc1);
export default __webpack_public_path__ + "static/media/func1.8b20e20c6cf1003c973a8f5bc086aeb3.svg";
export { ForwardRef as ReactComponent };